import $ from 'jquery';

export default () => {
  const $window = $(window);
  $window.on('scroll', e => {
    if ($(e.target).scrollTop() >= 105) {
      $('body').addClass('fixed');
    } else {
      $('body').removeClass('fixed');
    }
  });
};



// WEBPACK FOOTER //
// ./src/plugins/fixed-actions.js